import React from 'react';
import Collapsible from 'react-collapsible';

class ErrorFallback extends React.Component {
  // const [open, setOpen] = useState(false);
  state = {
    open: false,
  };
  setOpen = () => {
    this.setState({ open: !this.state.open });
  };
  render() {
    const { error, errorInfo } = this.props;
    const { open } = this.state;

    const isAdmin = localStorage.getItem('isAdmin');

    return (
      <div className="error_page" role="alert">
        <p className="heading">
          {isAdmin
            ? 'Oops, it looks like you broke something 😬.'
            : 'It looks like we broke something'}
        </p>
        <img className="b_image" alt="broken code" src="/img/broken_site.svg" />

        {isAdmin && (
          <div style={{ marginTop: '30px' }}>
            <div className="message_title">A message from the I/O</div>
            <div className="error_body">
              <Collapsible
                contentInnerClassName="inner-collapsible"
                trigger={
                  <div onClick={this.setOpen} className="error_trigger hover">
                    <img
                      className={`toggle_img ti-arrow-down  ${open ? 'open' : ''}`}
                      src="/img/grey_caret.svg"
                      alt="toggle"
                    />
                    <span className="error_text bold">{error.message}</span>
                  </div>
                }
              >
                <div
                  onClick={this.setOpen}
                  className="error_details error_text"
                  style={{ whiteSpace: 'pre-wrap' }}
                >
                  {errorInfo.componentStack}
                </div>
              </Collapsible>
            </div>
          </div>
        )}
        <div style={{ margin: '20px 0' }} />
        <button
          className="li_retry_transaction"
          onClick={() => {
            window.location = '/';
          }}
        >
          Go Home
        </button>
      </div>
    );
  }
}

export default ErrorFallback;



// WEBPACK FOOTER //
// ./src/ErrorFallBackComponent.js